import { BaseModel } from "../base-model";
import { GenericBaseParameter } from "../base-parameter";
//#region list data
export interface IPersonProposalDemandListingModel {
  Id?: number;
  MatchingCount?: number;
}
export class PersonProposalDemandListingModel
  extends BaseModel<IPersonProposalDemandListingModel>
  implements IPersonProposalDemandListingModel {
  
  Id?: number;
  MatchingCount?: number;
  constructor(option?: IPersonProposalDemandListingModel) {
    super(option);
    this.MatchingCount = 0;
  }
}

//#endregion

//#region search condition
export interface IPersonProposalDemandParameterModel {
  PersonId?: number;
}
export class PersonProposalDemandParameterModel
  extends GenericBaseParameter<IPersonProposalDemandParameterModel>
  implements IPersonProposalDemandParameterModel {
  PersonId: number;
  constructor(option?: IPersonProposalDemandParameterModel) {
    super();
    Object.keys(option).forEach(key => (this[key] = option[key]));
  }
}
//#endregion
